import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_MANUFACTURER_NOTES_ERROR:
    'settings/digitalQuote/FETCH_MANUFACTURER_NOTES_ERROR',
  FETCH_MANUFACTURER_NOTES_SUCCESS:
    'settings/digitalQuote/FETCH_MANUFACTURER_NOTES_SUCCESS',

  UPDATE_MANUFACTURER_NOTES_ERROR:
    'settings/digitalQuote/UPDATE_MANUFACTURER_NOTES_ERROR',
  UPDATE_MANUFACTURER_NOTES_REQUEST:
    'settings/digitalQuote/UPDATE_MANUFACTURER_NOTES_REQUEST',
  UPDATE_MANUFACTURER_NOTES_SUCCESS:
    'settings/digitalQuote/UPDATE_MANUFACTURER_NOTES_SUCCESS',
};

export const fetchManufacturerNotes = {
  error: () => ({
    type: types.FETCH_MANUFACTURER_NOTES_ERROR,
  }),
  success: ({ manufacturerNotes }) => ({
    type: types.FETCH_MANUFACTURER_NOTES_SUCCESS,
    payload: { manufacturerNotes },
  }),
};

export const updateManufacturerNotes = {
  error: notify(
    (error) => ({
      type: types.UPDATE_MANUFACTURER_NOTES_ERROR,
      payload: error,
    }),
    "Can't update Manufacturer's Notes",
  ),
  request: ({ newManufacturerNotes }) => ({
    type: types.UPDATE_MANUFACTURER_NOTES_REQUEST,
    payload: { newManufacturerNotes },
  }),
  success: notify(
    ({ manufacturerNotes }) => ({
      type: types.UPDATE_MANUFACTURER_NOTES_SUCCESS,
      payload: { manufacturerNotes },
    }),
    'Success',
    "Manufacturer's Notes successfully updated",
  ),
};
